import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { BellSlash, Check, Warning } from "@phosphor-icons/react";

export default function Desabonnement() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setErrMsg("Lien invalide."); }
  }, [token]);

  const unsubscribe = async () => {
    setState("loading");
    try {
      await api.delete(`/subscriptions/by-token/${token}`);
      setState("done");
    } catch (err) {
      setState("error");
      setErrMsg(err.response?.data?.detail || "Impossible de désabonner ce lien.");
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16 text-center" data-testid="desabonnement-page">
        <div className="bg-white rounded-3xl p-8 border border-rose-100 shadow-[0_8px_30px_rgba(244,63,94,0.08)]">
          {state === "done" ? (
            <>
              <Check size={48} weight="duotone" className="text-emerald-500 mx-auto" />
              <h1 className="font-display text-2xl font-black text-stone-800 mt-3">Désabonnement confirmé</h1>
              <p className="text-stone-600 text-sm mt-2">Vous ne recevrez plus d'alertes par email pour ce département.</p>
              <Link to="/" className="inline-block mt-6"><Button className="rounded-full bg-orange-500 hover:bg-orange-600 px-6 py-6 font-bold">Retour à l'accueil</Button></Link>
            </>
          ) : state === "error" ? (
            <>
              <Warning size={48} weight="duotone" className="text-rose-500 mx-auto" />
              <h1 className="font-display text-2xl font-black text-stone-800 mt-3">Lien invalide</h1>
              <p className="text-stone-600 text-sm mt-2">{errMsg}</p>
            </>
          ) : (
            <>
              <BellSlash size={48} weight="duotone" className="text-rose-500 mx-auto" />
              <h1 className="font-display text-2xl font-black text-stone-800 mt-3">Se désabonner des alertes ?</h1>
              <p className="text-stone-600 text-sm mt-2">Vous ne recevrez plus d'emails d'alerte pour ce département. Vous pourrez toujours vous réabonner à tout moment.</p>
              <Button onClick={unsubscribe} disabled={state === "loading"} className="mt-6 rounded-full bg-rose-500 hover:bg-rose-600 px-8 py-6 font-bold" data-testid="confirm-unsubscribe">
                {state === "loading" ? "Désabonnement..." : "Confirmer le désabonnement"}
              </Button>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
